import script from "./PerformanceAppraisalAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceAppraisalAdd.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceAppraisalAdd.vue?vue&type=style&index=0&id=06c11c04&lang=css"

const __exports__ = script;

export default __exports__